// React
import React from 'react';

// Translations
import messages from '../DirectFeedbackUpload/messages';
import { useIntl } from 'react-intl';

const MailCatcherDescription = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <h4 className="text-lg text-primary-400">
        {formatMessage(messages.mailCatcherContainerTitle)}
      </h4>
      <div className="mb-20 text-black">
        <p className="p-0 mt-10">
          {formatMessage(
            messages.mailCatcherContainerBookingConfirmationDescription
          )}
        </p>
        <p className="p-0 mt-15">
          {formatMessage(messages.mailCatcherContainerMailbox, {
            strong: (...chunks) => <strong>{chunks}</strong>,
          })}
        </p>
        <p className="p-0 mt-15">
          {formatMessage(messages.mailCatcherContainerMailSearch, {
            strong: (...chunks) => <strong>{chunks}</strong>,
          })}
        </p>
        <p className="p-0 mt-15">
          {formatMessage(messages.mailCatcherContainerMailForward, {
            strong: (...chunks) => <strong>{chunks}</strong>,
          })}
        </p>
      </div>
    </>
  );
};

export default MailCatcherDescription;
